import { createDisplayName } from "@domains/utils/displayName";
export const MultiQuoteMapper = (data) => {
    let mulitQuoteEntity = {
        quotesDetailsEntity: [],
    };
    mulitQuoteEntity.quotesDetailsEntity = listMapper(data.syLst);
    return mulitQuoteEntity;
};
const listMapper = (data) => {
    let finalList = [];
    if (data && data.length > 0) {
        data.map((syRecord) => {
            let listObj = {
                displayName: createDisplayName(syRecord),
                symbol: syRecord.sym,
                tradeSymbol: syRecord.trdSym,
                dpName: syRecord.dpNm,
                lastTradedPrice: syRecord.ltp ? Number(syRecord.ltp).toString() : "",
                change: syRecord.chg ? Number(syRecord.chg).toString() : "",
                changePercentage: syRecord.chgP ? Number(syRecord.chgP).toString() : "",
                description: syRecord.desc,
                updatedTime: syRecord.lut,
                lotSize: syRecord.ltSz,
                exchange: syRecord.exc,
                maxLotSize: syRecord.mxLtSz,
                prcUnits: syRecord.prcUnits,
                qtyUnits: syRecord.qtyUnits,
                type: syRecord.asTyp,
                isin: syRecord.isin,
                asExchange: syRecord.asExc,
                asSymbol: syRecord.asSym,
                yearHigh: syRecord.yrH,
                yearLow: syRecord.yrLw,
                tickSize: syRecord.tkSz,
                lowerCircuit: syRecord.loCt,
                higherCircuit: syRecord.hiCt,
                asTyp: syRecord.asTyp,
            };
            finalList.push(listObj);
        });
    }
    return finalList;
};
